import type { FC } from 'react';
import type { LineProps } from './index';

export const RectLine: FC<LineProps> = ({ color, width, height }) => {
    return (
        <svg width={width} height="8" viewBox="0 0 90 8" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M8 4H16" stroke={color} strokeWidth={height} />
            <path d="M24 4H32" stroke={color} strokeWidth={height} />
            <path d="M40 4H48" stroke={color} strokeWidth={height} />
            <path d="M56 4H64" stroke={color} strokeWidth={height} />
            <path d="M72 4L80 4" stroke={color} strokeWidth={height} />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8 7L8 1H0V7L8 7ZM24 7V1H16V7L24 7ZM40 1V7L32 7V1H40ZM56 7V1H48V7L56 7ZM72 1V7L64 7V1H72ZM88 7V1H80V7L88 7Z"
                fill={color}
            />
        </svg>
    );
};
